export enum BalanceType {
  Available,
  Hold,
}
